// src/pages/admin/users/UsersTable.jsx
import { useEffect, useMemo, useState } from "react";
import {
  Table,
  Input,
  Button,
  Modal,
  Descriptions,
  Tag,
  Space,
  Typography,
  Image,
  message,
} from "antd";
import axios from "../../../requests/axios";
import routes from "../../../requests/routes";
import TableWithExport from "../../../generic components/TableWithExport/TableWithExport";
import {
  getName,
  getEmail,
  getPhone,
  clean,
  getCreated,
  fmtDate,
} from "../../../generic components/TableWithExport/TableWithExport.utils";
const { Text } = Typography;

export const SpecialRequests = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.get(routes.specialRequest);
      const list = res?.data?.requests || res?.data || [];
      setData(Array.isArray(list) ? list : []);
    } catch (e) {
      console.error("Users fetch error:", e?.message);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return data;
    return data.filter((u) =>
      [getName(u), getEmail(u), getPhone(u)]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(s))
    );
  }, [q, data]);

  const columns = [
    { title: "#", width: 64, align: "center", render: (_v, _r, i) => i + 1 },
    {
      title: "Name",
      sorter: (a, b) => getName(a).localeCompare(getName(b)),
      render: (_, r) => <Text strong>{getName(r) || "—"}</Text>,
    },
    {
      title: "Email",
      sorter: (a, b) => getEmail(a).localeCompare(getEmail(b)),
      render: (_, r) => <Text copyable>{getEmail(r) || "—"}</Text>,
    },
    {
      title: "Phone",
      responsive: ["md"],
      render: (_, r) => getPhone(r) || "—",
    },
    {
      title: "Created",
      width: 200,
      sorter: (a, b) =>
        new Date(getCreated(a) || 0) - new Date(getCreated(b) || 0),
      render: (_, r) => fmtDate(getCreated(r)),
    },
    {
      title: "Actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            onClick={() => {
              setCurrent(record);
              setOpen(true);
            }}
          >
            Show
          </Button>
          <Button
            danger
            type="link"
            onClick={() => {
              Modal.confirm({
                title: "Delete special request",
                content:
                  "Are you sure you want to delete this special request?",
                okText: "Delete",
                okType: "danger",
                cancelText: "Cancel",
                onOk: async () => {
                  try {
                    await axios.delete(routes.deleteSpecialRequest(record._id));
                    message.success("Special request deleted");
                    fetchUsers();
                  } catch (e) {
                    message.error("Failed to delete special request");
                  }
                },
              });
            }}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h2 className="adminTitle">Special Requests</h2>

      <TableWithExport
        setCurrent={setCurrent}
        setOpen={setOpen}
        data={data}
        loading={loading}
        columns={columns}
        tableName={"special_requests"}
        filters={false}
      />

      {/* Details Modal */}
      <Modal
        open={open}
        title={getName(current) || "User details"}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
        width={720}
      >
        {current && (
          <Descriptions column={1} size="middle" colon>
            <Descriptions.Item label="Email">
              <Text copyable>{getEmail(current)}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Full name">
              {getName(current) || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {getPhone(current) || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Type">
              {clean(current.type) || "—"}
            </Descriptions.Item>

            <Descriptions.Item label="Destination">
              {clean(current.destination) || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Description">
              {clean(current.description) || "—"}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default SpecialRequests;
